// extracted by mini-css-extract-plugin
export default {"main":"Portfolio_main__4y2qP","main_back":"Portfolio_main_back__Jdkkk","main_bunner":"Portfolio_main_bunner__UYKeg"};